module.exports = __webpack_public_path__ + "static/01-d537b7c2204ba38170f3bdb786fc5c10.jpg";